import { PropsWithChildren } from "react";
import Drawer from "common/Drawers/Drawer.tsx";
import styled from "styled-components";
import useSwipeDrawer from "common/Gestures/useSwipeDrawer.ts";

interface SwipeDrawerProps {
  content?: React.JSX.Element;
  disabled?: boolean;
}

const SwipeDrawer = ({
  content,
  disabled,
  children,
}: PropsWithChildren<SwipeDrawerProps>) => {
  const isDisabled = !content || disabled;
  const { open, closeDrawer, swipeDrawerProps } = useSwipeDrawer({
    isDisabled,
  });

  return (
    <SwipeDrawerWrapper {...swipeDrawerProps}>
      {children}
      <Drawer
        open={open}
        onClose={closeDrawer}
        size={300}
        placement="right"
        closable={false}
        destroyOnHidden={false}
        styles={STYLE}
      >
        {content}
      </Drawer>
    </SwipeDrawerWrapper>
  );
};

export default SwipeDrawer;

const STYLE = { body: { padding: 16 } };

const SwipeDrawerWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
